"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddArticle = AddArticle;
exports.DelArticle = DelArticle;
exports.ListArticle = ListArticle;
exports.UpdateArticle = UpdateArticle;
exports.getComDetail = getComDetail;
exports.getSettingDetail = getSettingDetail;
exports.submitSetting = submitSetting;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 列表
 * @param pram
 * @constructor
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = {
    page: pram.page,
    limit: pram.limit
  };
  return (0, _request.default)({
    url: '/admin/api/template/list',
    method: 'GET',
    params: data
  });
}

/**
 * 新增
 * @param data
 * @constructor
 */
function AddArticle(data) {
  var submitInfo = _objectSpread({}, data);
  delete submitInfo.id;
  return (0, _request.default)({
    url: '/admin/api/template/save',
    method: 'post',
    params: submitInfo
  });
}

/**
 * 更新
 * @param data
 * @constructor
 */
function UpdateArticle(data) {
  return (0, _request.default)({
    url: '/admin/api/template/update',
    method: 'put',
    params: data
  });
}

/**
 * 删除
 * @param id
 * @constructor
 */
function DelArticle(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/api/template/delete',
    method: 'delete',
    params: data
  });
}

/**
 * 详情
 * @param id
 * @constructor
 */
function getComDetail(id) {
  return (0, _request.default)({
    url: '/admin/api/template/query',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 系统配置查询
 * @returns 
 */
function getSettingDetail() {
  return (0, _requestMapi.default)({
    url: '/mapi/system/config/info',
    method: 'GET',
    params: {
      formId: 999 // 后端让写死。。。。
    }
  });
}

/**
 * 修改系统配置
 * @param {*} id
 * @returns
 */
function submitSetting(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/system/config/back',
    method: 'post',
    data: data
  });
}